import { openOverlay } from ".."
import type { OverlayOptions } from "../OverlayController"
import Confirm from "./Confirm.svelte"
import MultiButton from "./MultiButton.svelte"
import Popup from "./Popup.svelte"
import Text from "./Text.svelte"
import type {
	ConfirmInputOptions,
	MultiButtonOptions,
	ConfirmPromiseOptions,
	PopupInputOptions,
	TextInputOptions,
} from "./types"
import { ImageViewer } from "misc-ui"
import YouTubeEmebd from "./YouTubeEmebd.svelte"

export function openConfirmOverlay(
	options: ConfirmInputOptions,
	overlayConfig?: OverlayOptions<any>
) {
	return openOverlay(Confirm, {
		classOverlay: "flex-column center-ver confirm-overlay",
		...overlayConfig,
		props: options as any,
	})
}

export function asyncConfirmOverlay<T extends {}>(
	options: ConfirmPromiseOptions,
	overlayConfig?: OverlayOptions<T>
) {
	return new Promise((res, rej) => {
		openConfirmOverlay(
			{
				prompt: options.prompt,
				invertWarning: false,
				buttons: {
					confirm: {
						text: options.confirmText,
						onClick: () => res(null),
					},
					deny: {
						text: options.denyText,
						onClick: () => rej(null),
					},
				},
			},
			{
				classHeading: "no-underline",
				...overlayConfig,
				heading: options.title,
				beforeClose: async () => rej(null),
			}
		)
	})
}

export function openMultiButtonOverlay(
	options: MultiButtonOptions,
	overlayConfig?: OverlayOptions<any>
) {
	return openOverlay(MultiButton, {
		classOverlay: "flex-column center-ver confirm-overlay",
		...overlayConfig,
		props: options,
	})
}

export function initConfirmOverlay(
	options: ConfirmInputOptions,
	overlayConfig?: OverlayOptions<any>
) {
	return (e: MouseEvent) => {
		openOverlay(Confirm, {
			classOverlay: "flex-column center-ver",
			...overlayConfig,
			props: options as any,
		})
	}
}

export function openPopupOverlay(options?: PopupInputOptions, overlayConfig?: OverlayOptions<any>) {
	openOverlay(Popup, {
		classOverlay: "flex-column center-ver popup",
		...overlayConfig,
		props: options as any,
	})
}

export function initPopupOverlay(options?: PopupInputOptions, overlayConfig?: OverlayOptions<any>) {
	return (e: MouseEvent) => {
		openOverlay(Popup, {
			classOverlay: "flex-column center-ver",
			...overlayConfig,
			props: options as any,
		})
	}
}

export function openTextOverlay(options: TextInputOptions, overlayConfig?: OverlayOptions<any>) {
	openOverlay(Text, { ...overlayConfig, props: options as any })
}

export function initTextOverlay(options: TextInputOptions, overlayConfig?: OverlayOptions<any>) {
	return (e: MouseEvent) => {
		openOverlay(Text, { ...overlayConfig, props: options as any })
	}
}

export function openImageOverlay(images: Array<string>, overlayConfig?: OverlayOptions<any>) {
	openOverlay(ImageViewer, {
		...overlayConfig,
		classOverlay: "image-overlay",
		props: { images },
	})
}

export function openYouTubeVideoOverlay(url: string, title: string) {
	openOverlay(YouTubeEmebd, {
		classOverlay: "no-padding can-grow",
		hideExitButton: true,
		props: {
			videoURL: url,
			title,
		},
	})
}
